type SectionTab = {
  value: string;
  label: string;
  description?: string;
};

type SectionTabsProps = {
  value: string;
  tabs: SectionTab[];
  onChange: (value: string) => void;
  ariaLabel: string;
};

export function SectionTabs({ value, tabs, onChange, ariaLabel }: SectionTabsProps) {
  return (
    <nav className="bkux-section-tabs" aria-label={ariaLabel} role="navigation">
      {tabs.map((tab) => {
        const selected = tab.value === value;
        return (
          <button
            className={`bkux-section-tabs__button ${selected ? 'bkux-section-tabs__button--active' : ''}`}
            type="button"
            key={tab.value}
            aria-current={selected ? 'page' : undefined}
            onClick={() => onChange(tab.value)}
          >
            <span>{tab.label}</span>
            {tab.description ? <small>{tab.description}</small> : null}
          </button>
        );
      })}
    </nav>
  );
}
